var map = {
	"./account.svg": 6589,
	"./american-express.svg": 9241,
	"./atome.svg": 212,
	"./cart.svg": 5690,
	"./facebook.svg": 1524,
	"./google.svg": 3053,
	"./maestro.svg": 4151,
	"./mastercard.svg": 6628,
	"./search.svg": 44,
	"./telegram.svg": 5265,
	"./truck.svg": 289,
	"./visa.svg": 6703,
	"./whatsapp.svg": 6450
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 616;